import React from 'react'
import { StarChartAssignOrganizationContainerProps } from '../../types/types'
import StarChartAssignOrganizationPresentation from '../../presentation/starChart.assign.organization.presentation/StarChartAssignOrganizationPresentation'

const StarChartAssignOrganizationContainer: React.FC<StarChartAssignOrganizationContainerProps> = ({starChartAssignArg , assignArgPopup}) => {

  return (
    <StarChartAssignOrganizationPresentation starChartAssignArg={starChartAssignArg} assignArgPopup={assignArgPopup}/>

  )
}

export default StarChartAssignOrganizationContainer

